import { supportedAllMovementRegexTest } from 'components/SwitchTableMovements/SwitchTableMovements.helpers';
import {
  listBetsState,
  listBetsToto,
  listBetsType,
} from 'components/SwitchTableMovements/partials/TableBets/TableBets.config';
import {
  listApplicationCode,
  listPlayState,
} from 'components/SwitchTableMovements/partials/TableGntnPlay/TableGntnPlay.config';
import { listTransactionState } from 'components/SwitchTableMovements/partials/TableLitPlayList/TableLitPlayList.config';
import { APP_COUNTRY } from 'config';
import {
  AllMovementsSection,
  defaultSelectMovementsOption,
  supportedTabsRegex,
} from 'pages/AllMovements/AllMovements.config';
import { defaultParamsMovementProps } from 'pages/AllMovements/AllMovements.types';

export function computeCurrentParamsMovements(
  queryParams: Record<string, string>,
) {
  const {
    type,
    period,
    stateBets,
    playState,
    applicationCode,
    betsType,
    transactionState,
    onlyWinnings,
    totocalcioType,
    hideNavigation,
  } = queryParams;

  const currentParams = {} as defaultParamsMovementProps;

  if (type && supportedTabsRegex.test(type)) {
    currentParams.typeId = parseInt(type, 10);
  } else {
    currentParams.typeId = defaultSelectMovementsOption;
  }

  if (period) {
    currentParams.period = parseInt(period, 10);
  }

  if (stateBets && supportedAllMovementRegexTest(listBetsState, stateBets)) {
    currentParams.stateBets = parseInt(stateBets, 10);
  }
  if (playState && supportedAllMovementRegexTest(listPlayState, playState)) {
    currentParams.playState = parseInt(playState, 10);
  }
  if (
    applicationCode &&
    supportedAllMovementRegexTest(listApplicationCode, applicationCode)
  ) {
    currentParams.applicationCode = parseInt(applicationCode, 10);
  }
  if (betsType && supportedAllMovementRegexTest(listBetsType, betsType)) {
    currentParams.betsType = parseInt(betsType, 10);
  }
  if (
    transactionState &&
    supportedAllMovementRegexTest(listTransactionState, `${transactionState}`)
  ) {
    currentParams.transactionState = parseInt(transactionState, 10);
  }
  if (onlyWinnings) {
    currentParams.onlyWinnings = onlyWinnings === 'true';
  }
  if (
    totocalcioType &&
    supportedAllMovementRegexTest(listBetsToto, totocalcioType)
  ) {
    currentParams.totocalcioType = parseInt(totocalcioType, 10);
  }
  currentParams.hideNavigation =
    hideNavigation === 'true' ? 'true' : hideNavigation;
  return currentParams;
}

export const filterByCountry = (list: number[]) => {
  switch (APP_COUNTRY) {
    case 'pt':
      return list.filter(
        (item) =>
          item !== AllMovementsSection.bets &&
          item !== AllMovementsSection.sportBets,
      );
    case 'fr':
      return list.filter((item) => item !== AllMovementsSection.casinoAndSlots);
    case 'es':
      return list;
    default:
      return list;
  }
};
